// src/services/geral/CidadeCepService.js
import { fetchData, postData, deleteData } from '../Api';
import { normalizarCep } from '../../models/geral/CidadeCep';

export const listarCeps = async (cidadeId) => await fetchData('/CidadeCep', { cidadeId });
export const adicionarCep = async (registro) => await postData('/CidadeCep', {
  cidadeId: Number(registro.cidadeId), cep: normalizarCep(registro.cep),
});
export const excluirCep = async (id) => await deleteData(`/CidadeCep/${id}`);
export const consultarCep = async (cep) => {
  try { return await fetchData('/CidadeCep/PorCep', { cep: normalizarCep(cep) }); }
  catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
};
